import script from "./md-empty.vue?vue&type=script&lang=js"
export * from "./md-empty.vue?vue&type=script&lang=js"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/cms-preview/md-empty.vue'],['__file',"md-empty.vue"]])

export default __exports__